{
  "Accessibility menu": "Menu Trợ Năng",
  "Reset settings": "Đặt lại cài đặt",
  "Close": "Đóng",
  "Content adjustments": "Điều Chỉnh Nội Dung",
  "Navigation adjustments": "Điều Chỉnh Điều Hướng",
  "Align Left": "Căn Trái",
  "Adjust Font Size": "Điều Chỉnh Cỡ Chữ",
  "Highlight Title": "Đánh Dấu Tiêu Đề",
  "Highlight Links": "Đánh Dấu Liên Kết",
  "Readable Font": "Phông Chữ Dễ Đọc",
  "Colour adjustments": "Điều Chỉnh Màu Sắc",
  "Dark Contrast": "Tương Phản Tối",
  "Light Contrast": "Tương Phản Sáng",
  "High Contrast": "Tương Phản Cao",
  "High Saturation": "Bão Hòa Cao",
  "Low Saturation": "Bão Hòa Thấp",
  "Monochrome": "Đơn Sắc",
  "Tools": "Công Cụ",
  "Reading Guide": "Hướng Dẫn Đọc",
  "Stop Animations": "Dừng Hoạt Ảnh",
  "Big Cursor": "Con Trỏ Lớn",
  "Increase Font Size": "Tăng Cỡ Chữ",
  "Decrease Font Size": "Giảm Cỡ Chữ",
  "Letter Spacing": "Khoảng Cách Chữ",
  "Line Height": "Chiều Cao Dòng",
  "Font Weight": "Độ Đậm Chữ",
  "Dyslexia Font": "Phông Chữ Cho Chứng Khó Đọc",
  "Language": "Ngôn Ngữ",
  "Accessibility widget": "Mở Menu Trợ Năng",
  "Accessibility Profiles": "Hồ Sơ Trợ Năng",
  "Cognitive Disability": "Khuyết Tật Nhận Thức",
  "Seizure Safe": "An Toàn Cho Động Kinh",
  "Accessibility statement": "Tuyên Bố Trợ Năng"
}
